import {Injectable} from '@angular/core';

@Injectable()
export class AppConstants {
    static markingSchemes = [
        {name: 'Percentage', value: 'PERCENTAGE'},
        {name: 'CGPA', value: 'CGPA'}
    ];

    static boardUniversity = [
        {name: 'CBSE', value: 'CBSE'},
        {name: 'ICSE', value: 'ICSE'},
        {name: 'IB', value: 'IB'},
        {name: 'State Board', value: 'STATE_BOARD'}
    ];

    static categories = [
        {name: 'General', value: 'GENERAL'},
        {name: 'OBC', value: 'OBC'},
        {name: 'SC', value: 'SC'},
        {name: 'ST', value: 'ST'},
        {name: 'Others', value: 'OTHERS'},
    ];

    static employementStatuses = [
        {name: 'Employed', value: 'EMPLOYED'},
        {name: 'Un-Employed', value: 'UN_EMPLOYED'},
    ];

    static ticketStatuses = [
        {
            name: 'Pending',
            value: 'PENDING'
        },
        {
            name: 'Resoled',
            value: 'RESOLVED'
        },
        {
            name: 'Withdrawn',
            value: 'WITHDRAWN'
        },
        {
            name: 'To be Taken Later',
            value: 'TO_BE_TAKEN_LATER'
        }
    ];

    static schools = [
        {
            id: 1,
            name: 'Arni School of Technology',
            image_url: './assets/img/aarni-schools/school-of-technology.jpg',
            description: 'The ARNI School of Technologies (AST), the place where ideas turn into reality.',
            url: '/schools/arni-school-of-technology'
        },
        {
            id: 2,
            name: 'Arni School of Business Management & Commerce',
            image_url: './assets/img/aarni-schools/management-and-commerce.jpg',
            description: 'The ARNI School of Business Management & Commerce is the place where potential leaders transform into business professionals.',
            url: '/schools/arni-school-of-business-management-and-commerce'
        },

        {
            id: 3,
            name: 'Arni School of Art & Humanities',
            image_url: './assets/img/aarni-schools/humanities.jpg',
            description: 'The School of Arts and Humanities at ARNI University is the place where culture, communication, and creativity take flight to the diversified career opportunities.',
            url: '/schools/arni-school-of-art-and-humanities'
        },
        {
            id: 4,
            name: 'Arni School of Basic Sciences & Bio-Technology',
            image_url: './assets/img/aarni-schools/science-and-bio-technologies.jpg',
            description: 'The ARNI School of Basic Science & Biotechnology, the intersection of innovation and inquiry. It offers a nourished ground for aspiring researchers, biotechnologists, and scientists.',
            url: '/schools/arni-school-of-basic-science-and-biotechnology'
        },

        {
            id: 5,
            name: 'Arni School of Allied Health Sciences',
            image_url: './assets/img/aarni-schools/health-and-sciences.jpg',
            description: 'The ARNI School of Allied Health Sciences provides a dynamic learning environment that merges theoretical knowledge with practical skills and practice to train students for the healthcare industry.',
            url: '/schools/arni-school-of-allied-health-science'
        },
        {
            id: 6,
            name: 'Arni School of Pharmacy',
            image_url: './assets/img/aarni-schools/school-of-pharmacy.jpg',
            description: 'ARNI School of Pharmacy stands as a pillar of excellence in pharmaceutical education, research, and healthcare innovations.',
            url: '/schools/arni-school-of-pharmacy'
        },
        {
            id: 7,
            name: 'Arni School of Agriculture',
            image_url: './assets/img/aarni-schools/agriculture-school.jpg',
            description: 'ARNI The School of Agriculture is dedicated to preparing the upcoming generation of agriculture leaders and researchers who will lead the future of sustainable farming, rural development, and food security.',
            url: '/schools/arni-school-of-agriculture'
        },
        {
            id: 8,
            name: 'Arni School of Law',
            image_url: './assets/img/aarni-schools/school-of-law.jpg',
            description: 'ARNI School of Law has been termed as the best place to nurture future leaders in legal practices among many other Law Colleges.',
            url: '/schools/arni-school-of-law'
        },
        {
            id: 9,
            name: 'Arni School of Hotel Management & Tourism',
            image_url: './assets/img/aarni-schools/hotel-management-and-tourism.jpg',
            description: 'The ARNI School of Hotel Management is a vibrant hub of aspiring hospitality professionals, combining creativity, professionalism, and a global outlook.',
            url: '/schools/arni-school-of-hotel-management'
        },
        {
            id: 10,
            name: 'Arni School of Education & Sports',
            image_url: './assets/img/aarni-schools/education-and-sports.jpg',
            description: 'The ARNI School of Education and Sports is a combination of teaching physical education with science.',
            url: '/schools/arni-school-of-education'
        },
    ];

    static exceptionRoutes = ['tickets'];
}
